export class ApproveRequestModel {
    requestItemId?: number;
    isApproved?: boolean;
    approvedByUserId?: number;
    comment?: string;
    approvalTimeStamp?: Date;
    commentType?: string;
}
